<template>
    <section class="team">
        <van-tabbar v-model="active" @change="changeTabbar" active-color="#055CE8" inactive-color="#9BA5B7">
            <van-tabbar-item name="team">
                <span>团队</span>
                <template #icon="props">
                    <img :src="props.active ? teamActivedIcon : teamUnactivedIcon" />
                </template>
            </van-tabbar-item>
            
            <van-tabbar-item name="promotion" v-if="token && accountType == 2">
                <span>推广</span>
                <template #icon="props">
                    <img :src="props.active ? promotionActivedIcon : promotionUnactivedIcon" />
                </template>
            </van-tabbar-item>

            <van-tabbar-item name="customer">
                <span>客户</span>
                <template #icon="props">
                    <img :src="props.active ? customerActivedIcon : customerUnactivedIcon" />
                </template>
            </van-tabbar-item>

            <van-tabbar-item name="setting">
                <span>设置</span>
                <template #icon="props">
                    <img :src="props.active ? settingActivedIcon : settingUnactivedIcon" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
        <Login :isLoginModel="isLoginModel" :type="type" :topLeftArrow="topLeftArrow" @closeModel="isLoginModel = false"
            @loginStatus="loginStatus" @loginModelFn="loginModelFn" />
        <section class="top_c">
            <img class="bg" src="../../assets/img/nav_bg.png" alt="">
            <img class="btn" v-if="accountType !=2 " src="../../assets/img/team_plus_icon.png" alt="" @click="teamPlusFn">
        </section>
        <section v-if="isData" class="data_class">
            <div v-for="(group,index) in groupedAccounts" :key="index" class="group">
                <div class="header">
                    <h2 @click="skipTeamDetails(group.groupId)">{{ group.name }}</h2>
                    <van-icon name="arrow" v-if="group.groupId > 0 && accountType == 0" />
                </div>
                <ul>
                    <li v-for="account in group.accounts" :key="account.id" @click="skipAccountDetails(account.id)">
                        <img v-if="account.gender == 1" src="../../assets/img/man.svg" alt="">
                        <img v-if="account.gender == 2" src="../../assets/img/woman.svg" alt="">
                        <img v-if="!account.gender" src="../../assets/img/someone.svg" alt="">
                        <span class="name">{{ account.name }}</span>
                        <span class="type">{{ account.accountType | f_accountType }}</span>
                        <span v-if="account.status==1" class="status">已停用</span>

                        <span class="right" v-if="account.id == myAccountId">我</span>
                    </li>
                </ul>
            </div>
        </section>
        <section v-if="!token || !isData" class="nodata_class">
            <div class="no_data">
                <img src="../../assets/img/team_default.png">
                <p>点击右上角添加团队账户</p>
            </div>
        </section>
        <section v-if="accountType==2" class="nodata_class">
            <div class="no_data">
                <img src="../../assets/img/team_default.png">
                <p>无查看权限</p>
            </div>
        </section>
    </section>
</template>

<script>
import Login from "components/Login";
import teamServer from "api/team";
import settingServer from "api/setting";
import { Toast } from 'vant';

import teamActivedIcon from "assets/img/team_icon_actived.png"
import teamUnactivedIcon from "assets/img/team_icon_unactived.png"
import promotionActivedIcon from "assets/img/promotion_icon_actived.png"
import promotionUnactivedIcon from "assets/img/promotion_icon_unactived.png"
import customerActivedIcon from "assets/img/customer_icon_actived.png"
import customerUnactivedIcon from "assets/img/customer_icon_unactived.png"
import settingActivedIcon from "assets/img/setting_icon_actived.png"
import settingUnactivedIcon from "assets/img/setting_icon_unactived.png"

export default {
    name: 'team',
    components: {
        Login,
    },
    data() {
        return {
            teamActivedIcon,
            teamUnactivedIcon,
            promotionActivedIcon,
            promotionUnactivedIcon,
            customerActivedIcon,
            customerUnactivedIcon,
            settingActivedIcon,
            settingUnactivedIcon,

            token: '',
            active: 'team',
            isData: 1,
            isLoginModel: false,
            topLeftArrow: true,
            type: 'login',

            params: {
                pageNum: 1,
                pageSize: 1000,
            },
            list: [],

            myAccountId: 0,
            accountType: '',
            
            accountInfo: {},
            orgInfo: {},
        };
    },
    created() {
        this.token = localStorage.getItem('token')

        if (this.token) {
            this.getInfo()
        } else {
            this.isLoginModel = true
        }
    },

    mounted() {
        if (this.$store.state.clientType == 2) {
            document.addEventListener('plusready', function () {
                var webview = plus.webview.currentWebview();
                plus.key.addEventListener('backbutton', function () {
                    webview.canBack(function (e) {
                        if (e.canBack) {
                            webview.back()
                        } else {
                            webview.close();
                        }
                    })
                })
            })
        }

        if(window.plus) {
            this.plusRead()
        }else {
            document.addEventListener('plusread', this.plusRead, false);
        }
    },

    computed: {
        groupedAccounts() {
            let groups = new Map();

            this.list.forEach(account => {
                let groupId;
                let groupName;
                
                if (account.accountType == 0) {
                    groupId = -1;
                    groupName = '机构管理员';
                } else {
                    groupId = account.teamId;

                    if (this.orgInfo.teamTotalQuota == 0) {
                        groupName = '我的团队';
                    } else {
                        groupName = account.teamName || '无归属团队';
                    }
                    
                }
                
                if (!groups.has(groupId)) {
                    groups.set(groupId, {
                        name: groupName,
                        accounts: []
                    });
                }
                
                if (account.accountType === 0 || account.accountType === 1) {
                    groups.get(groupId).accounts.unshift(account);
                } else {
                    groups.get(groupId).accounts.push(account);
                }
            });

            console.log(groups)

            // Create a new Map and add groupId=-1 first
            let orderedGroups = new Map();
            if (groups.has(-1)) {
                orderedGroups.set(-1, groups.get(-1));
                groups.delete(-1);
            }

            // Add the rest of the groups
            groups.forEach((value, key) => {
                orderedGroups.set(key, value);
            });

            // Convert Map to an Array for more standard data handling
            let resultArray = Array.from(orderedGroups, ([groupId, group]) => ({ groupId, ...group }));

            // Sort the array in ascending order by groupId
            resultArray.sort((a, b) => a.groupId - b.groupId);

            console.log(resultArray)

            return resultArray;
        }
    },

    methods: {
        plusRead() {
            // plus.navigator.setStatusBarBackground('#055CE8');
            // plus.navigator.setStatusBarStyle('light');
        },

        getInfo() {
            this.accountType = localStorage.getItem('accountType')

            if(localStorage.getItem('accountInfoJSONString')) {
                this.myAccountId = JSON.parse(localStorage.getItem('accountInfoJSONString')).id
            }

            if (this.accountType !=2) {
                this.getTeamInfo()
            }

            this.getAccountInfo()

            if (this.accountType == 0) {
                this.getOrgInfo()
            }
        },

        getOrgInfo() {
            settingServer.getOrgInfo().then((res) => {
                this.orgInfo = res.data
            })
        },

        getAccountInfo() {
            settingServer.getAccountInfo().then((res) => {
                this.accountInfo = res.data
            })
        },

        changeTabbar() {
            if (this.active == 'team') {
                this.$router.push({ name: 'team' })
            }

            if (this.active == 'promotion') {
                this.$router.push({ name: 'promotion' })
            }

            if (this.active == 'customer') {
                this.$router.push({ name: 'customer' })
            }

            if (this.active == 'setting') {
                this.$router.push({ name: "setting" });
            }
        },

        //登录回调
        loginStatus(status) {
            if (status == 'ok') {
                this.isLoginModel = false

                this.token = localStorage.getItem('token')
                this.getInfo()
            }
        },

        loginModelFn(type) {
            if (type == 'login') {
                this.topLeftArrow = true
            } else {
                this.topLeftArrow = false
            }
            this.type = type
            this.isLoginModel = true
        },

        getTeamInfo() {
            teamServer.getOrgUserPageList(this.params).then((res) => {
                if (res.data.total) {
                    this.isData = 1
                    this.list = res.data.list
                } else {
                    this.isData = 0
                }
            })
        },

        teamPlusFn() {
            if (!this.token) return this.isLoginModel = true

            if (this.accountInfo.authenticationStatus !=2) return Toast('请先完成账户认证')

            if (this.accountInfo.orgAuthenticationStatus !=2) return Toast('请先完成机构认证')

            if (this.accountInfo.subscriptionStatus !=1) return Toast('请先完成订阅')

            if (this.accountType == 2) return Toast('无权限操作')

            let canCreateTeam = 0

            if (this.orgInfo.teamTotalQuota >0 && this.accountType == 0) canCreateTeam = 1

            this.$router.push({ "name": "add-account", "params": { canCreateTeam: canCreateTeam} })
        },

        skipAccountDetails(id) {
            this.$router.push({ name: "account-details", params: {id: id} })
        },

        skipTeamDetails(id) {
            if (id<=0) return

            if (this.accountType != 0) return Toast('无权限操作')
            
            this.$router.push({ name: "team-details", params: {id: id} })
        }
    },
};
</script>

<style lang="scss">
.team {
    padding-bottom: 83px;

    .top_c {
        width: 100%;

        img.bg {
            width: 100%;
        }

        img.btn {
            position: absolute;
            top: 66px;
            right: 0;
            width: 88px;
            z-index: 999;
        }
    }

    .data_class {
        position: relative;
        margin-top: -80px;
        width: 100%;
        background-color: #f8f8f8;
        border-radius: 24px 24px 0 0;

        .group {
            background-color: #fff;
            border-radius: 24px;
            margin-bottom: 18px;
            padding: 26px 18px 18px 18px;

            .header {
                display: flex;
                align-items: center;
                // justify-content: space-between;

                h2 {
                    font-size: 17px;
                    color: #4D5B80;
                }
            }

            ul li {
                height: 48.4px;
                display: flex;
                align-items: center;
                margin-top: 18px;

                img {
                    width: 44px;
                }

                span.name {
                    margin-left: 22px;
                    color: #4D5B80;
                    font-size: 16px;
                }

                span.type {
                    margin-left: 4px;
                    color: #6d6d6d;
                    font-size: 12px;
                }

                span.status {
                    margin-left: 4px;
                    color: #d82323;
                    font-size: 12px;
                }

                span.right {
                    margin-left: auto;
                    color: #055CE8;
                    font-size: 13px;
                }
            }
        }
    }

    .nodata_class {
        position: absolute;
        top: 120px;
        width: 100%;
        height: 100%;
        background-color: #f8f8f8;
        display: flex;
        align-items: center;
        justify-content: center;

        .no_data {
            position: relative;
            top: -100px;

            img {
                width: 238px;
                display: inline-block;
            }

            p {
                padding-top: 22px;
                color: #4D5B80;
                font-size: 16px;
                text-align: center;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/index/Team.vue